
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/wink/paid-study/step01",
      function () {
        return require("private-next-pages/wink/paid-study/step01/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/wink/paid-study/step01"])
      });
    }
  